<template>
  <PubPage>
    <template slot="pageHeader">
      <div class="personList-header">
        <div class="personList-title">
          <div class="project-sh">查看已绑定学生 -</div>
          <div class="project-name">设备名称：{{ detail.name }}</div>
        </div>
      </div>
    </template>
    <BasicTable
      :columns="columns"
      bordered
      :dataSource="list"
      :loading="loading"
      boxShadow
      :pagination="{
        current: form.paging.page,
        pageSize: form.paging.limit,
        total: pageTotal,
      }"
      rowKey="faceDevicePersonnelRecordId"
      @searchBack="searchBack"
      @pagesChange="pagesChange"
      :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: (aa, bb) => {
          selectedRowKeys = aa;
        },
      }"
    >
      <template #tableTitle>
        <div class="pub-tableTitle-button">
          <a-button
            type="primary"
            class="btn-green"
            icon="plus-circle"
            @click="addPerson()"
            >新增学生</a-button
          >
          <a-button
            type="primary"
            class="btn-white"
            icon="delete"
            @click="deletePerson()"
            >批量删除</a-button
          >
        </div>
      </template>
      <template slot="type" slot-scope="{ record }">
        <PubStatus :status="record.type" type="PERSONNEL_TYPE" />
      </template>
      <template slot="workerType" slot-scope="{ record }">
        <PubStatus :status="record.workerType" type="TEAM_MANAGE_TYPE" />
      </template>
      <template slot="sycStatus" slot-scope="{ record }">
        <div class="personList-img">
          <PubStatus
            :status="record.sycStatus"
            type="DOCKING_PLATFORM_DATA_STATUS"
          />
          <BigImg :url="record.faceImageUrl" />
        </div>
      </template>

      <template slot="options" slot-scope="{ record }">
        <div class="pub-options">
          <a @click="authorizePer(record)"
            ><a-icon type="safety-certificate" />重新授权图片</a
          >
        </div>
      </template>
    </BasicTable>
    <ChangePersonModal ref="changePersonModal" @ok="moduleOk" />
  </PubPage>
</template>

<script>
import { Equipment } from "@/api";
import ChangePersonModal from "./ChangePerson.vue";
import BigImg from "@/components/PublicModals/BigImg";
export default {
  components: {
    ChangePersonModal,
    BigImg,
  },
  data() {
    const columns = [
      {
        title: "姓名",
        dataIndex: "name",
        align: "center",
      },
      {
        title: "身份证号",
        dataIndex: "idNumber",
        align: "center",
      },
      {
        title: "手机号码",
        dataIndex: "phone",
        align: "center",
      },
      {
        title: "所属单位",
        dataIndex: "participatingCompanyName",
        align: "center",
        hideInSearch: true,
      },
      {
        title: "所属单位",
        dataIndex: "participatingCompanyId",
        align: "center",
        hideInTable: true,
        valueType: "select",
        fieldProps: {
          placeholder: "请选择参建单位",
          option: () =>
            this.common.getProjectCompany(this.$route.query.projectId),
        },
      },
      {
        title: "人员类型",
        dataIndex: "type",
        align: "center",
        scopedSlots: true,
        hideInSearch: true,
      },
      {
        title: "工种",
        dataIndex: "workerType",
        align: "center",
        scopedSlots: true,
        hideInSearch: true,
      },
      {
        title: "班组名称",
        dataIndex: "teamManageName",
        align: "center",
        hideInSearch: true,
      },
      {
        title: "班组名称",
        dataIndex: "teamManageId",
        align: "center",
        hideInTable: true,
        valueType: "select",
        fieldProps: {
          placeholder: "请选择班组",
          associated: ["participatingCompanyId"],
          otherSear: ["companyId"],
          option: data =>
            this.common.getTeamManage(this.$route.query.projectId, data),
        },
      },
      {
        title: "授权状态",
        dataIndex: "sycStatus",
        align: "center",
        width: 125,
        scopedSlots: true,
        valueType: "select",
        fieldProps: {
          placeholder: "请选择状态",
          option: () => this.common.findSysCodeType("SYNC_STATUS"),
        },
      },
      {
        title: "操作",
        dataIndex: "options",
        align: "center",
        width: 130,
        scopedSlots: true,
        hideInSearch: true,
      },
    ];
    return {
      form: {
        deviceId: this.$route.query.id,
        projectId: this.$route.query.projectId,
        isInclude: 0, //0:人脸机绑定的人,1:没有在人脸机上面的人
        paging: {
          page: 1,
          limit: 20,
          sort: [
            {
              property: "createTime",
              direction: "DESC",
            },
          ],
        },
      },
      list: [],
      pageTotal: 0,
      loading: false,
      columns,
      detail: {},
      selectedRowKeys: [], // 已选择的ID
    };
  },
  created() {},
  mounted() {
    this.getList();
    this.getDetail();
  },
  methods: {
    // 获取详情数据
    getDetail() {
      this.loading = true;
      Equipment.faceDeviceFindOne({ id: this.form.deviceId }).then(res => {
        if (res.code == this.config.pubCode) {
          this.detail = res.data;
        }
        this.loading = false;
      });
    },
    // 获取数据
    getList() {
      this.loading = true;
      Equipment.findFaceDevicePersonnelInfo(this.form).then(res => {
        if (res.code == this.config.pubCode) {
          this.list = res.data;
          this.pageTotal = res.total;
        }
        this.loading = false;
      });
    },

    addPerson() {
      this.$refs.changePersonModal.open(
        this.form.deviceId,
        this.form.projectId
      );
    },
    moduleOk(data) {
      if (data) {
        this.getList();
      }
    },

    // 翻页回调
    pagesChange(data) {
      this.form.paging.page = data.current;
      this.form.paging.limit = data.pageSize;
      this.getList();
    },
    // 搜索回调
    searchBack(data) {
      data.paging = {
        ...this.form.paging,
        page: 1,
        limit: this.form.paging.limit,
      };
      this.form = { ...this.form, ...data };
      this.getList();
    },
    // 选择时回调
    changeRowKeys(data) {
      console.log(data);
      console.log(this.selectedRowKeys);
    },

    // 删除员工
    deletePerson() {
      console.log(this.selectedRowKeys);
      this.pubMsg.confirm("是否确定删除此选中的员工？").then(() => {
        this.loading = true;
        Equipment.deleteDevicePersonnelRecord({
          ids: this.selectedRowKeys.join(","),
        }).then(res => {
          if (res.code == this.config.pubCode) {
            this.pubMsg.tipMessage("删除成功！", "success");
            this.selectedRowKeys = [];
            this.loading = false;
            this.getList();
          }
        });
      });
    },
    // 重新授权图片
    authorizePer(data) {
      this.pubMsg.confirm("是否确定重新授权人员图片到此设备？").then(() => {
        this.loading = true;
        Equipment.authorizePersonnelInfoToFaceDevice({
          id: data.faceDevicePersonnelRecordId,
        }).then(res => {
          if (res.code == this.config.pubCode) {
            this.pubMsg.tipMessage("授权成功！", "success");
            this.loading = false;
            this.getList();
          }
        });
      });
    },
    // 查看员工
    goPersonDetail(data) {
      console.log(data);
      // this.$router.push({
      //   path:'/equipment/machineList/personList',
      //   query:{
      //     id: data.id,
      //   }
      // })
    },
  },
};
</script>
<style lang="less" scoped>
@import "./style.less";
</style>
